import { render, staticRenderFns } from "./gallerys.vue?vue&type=template&id=742c01d5&scoped=true&"
import script from "./gallerys.vue?vue&type=script&lang=js&"
export * from "./gallerys.vue?vue&type=script&lang=js&"
import style0 from "./gallerys.vue?vue&type=style&index=0&id=742c01d5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742c01d5",
  null
  
)

export default component.exports